module.exports = __webpack_public_path__ + "img/环保人之歌.cf559c41.png";